import NegativePrompt from "./NegativePrompt";
import Seed from "./Seed";
import InferenceSteps from "./InferenceSteps";
import GuidanceScale from "./GuidanceScale";

// Advanced Options panel in text-to-image and image-to-image
// generators; allows user to specify negative prompt,
// seed, inference steps, and guidance scale.
function AdvancedOptions(props) {
    return (
        <div id="advanced-options">
            {/* TODO: Update negative prompt to match state management model of other params */}
            <NegativePrompt negativePrompt={props.negativePrompt}/>
            <Seed seed={props.seed} setSeed={props.setSeed}/>
            <InferenceSteps steps={props.steps} setSteps={props.setSteps} />
            <GuidanceScale guidance={props.guidance} setGuidance={props.setGuidance} />
        </div>
    )
}

export default AdvancedOptions;